module.exports = __webpack_public_path__ + "static/media/Tooth_icon_f50d0d.6b7b75f7.svg";